export default __webpack_public_path__ + "static/media/goodbrands.0d098d0a.jpg";